import typeahead from 'typeahead.js/dist/typeahead.bundle';

export { typeahead };
